import React from "react";
import { Search, TrendingUp } from "lucide-react";

interface SearchItem {
  searchTerm: string;
  searchCount: number;
}

interface TopSearchesProps {
  searches?: SearchItem[];
}

const TopSearches: React.FC<TopSearchesProps> = ({ searches = [] }) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      {/* HEADER */}

      <div className="px-5 py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center">
            <Search size={18} />
          </div>

          <div>
            <h2 className="text-sm font-bold text-gray-800">Top Searches</h2>

            <p className="text-[10px] text-gray-400 mt-0.5">
              What customers are searching for
            </p>
          </div>
        </div>
      </div>

      {/* SEARCH LIST */}

      <div className="p-3">
        {searches.length > 0 ? (
          <div className="space-y-1">
            {searches.map((item, index) => (
              <div
                key={`${item.searchTerm}-${index}`}
                className="
                  flex
                  items-center
                  justify-between
                  gap-3
                  px-3
                  py-3
                  rounded-xl
                  hover:bg-gray-50
                  transition-colors
                "
              >
                <div className="flex items-center gap-3 min-w-0">
                  <span className="w-7 h-7 shrink-0 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center text-[10px] font-bold">
                    {index + 1}
                  </span>

                  <div className="min-w-0">
                    <p className="text-xs font-semibold text-gray-700 truncate">
                      {item.searchTerm}
                    </p>

                    <p className="text-[9px] text-gray-400 mt-0.5">
                      Customer search
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-1.5 shrink-0">
                  <TrendingUp size={12} className="text-amber-500" />

                  <span className="text-xs font-bold text-gray-700">
                    {item.searchCount.toLocaleString()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-10 text-center">
            <Search size={24} className="mx-auto text-gray-200" />

            <p className="text-xs text-gray-400 mt-2">No searches recorded.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopSearches;
